import React, { useState, useRef, useEffect, useCallback } from "react";
import "./Church3DViewer.css";

const Church3DViewer = ({ imagePath }) => {
  const [scale, setScale] = useState(1);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  const containerRef = useRef(null);

  const handleWheel = useCallback(
    (e) => {
      e.preventDefault();
      const zoomSpeed = 0.1;
      const newScale = e.deltaY > 0 ? scale - zoomSpeed : scale + zoomSpeed;
      setScale(Math.max(1, Math.min(5, newScale)));
    },
    [scale]
  );

  // Attach wheel event listener with passive: false to allow preventDefault()
  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      container.addEventListener("wheel", handleWheel, { passive: false });
      return () => {
        container.removeEventListener("wheel", handleWheel);
      };
    }
  }, [handleWheel]);

  const handleMouseDown = (e) => {
    if (scale > 1) {
      setIsDragging(true);
      setDragStart({ x: e.clientX - position.x, y: e.clientY - position.y });
    }
  };

  const handleMouseMove = (e) => {
    if (!isDragging || !containerRef.current) return;

    const newX = e.clientX - dragStart.x;
    const newY = e.clientY - dragStart.y;

    // Calculate max pan limits
    const containerWidth = containerRef.current.clientWidth;
    const containerHeight = containerRef.current.clientHeight;
    const maxX = (containerWidth * (scale - 1)) / 2;
    const maxY = (containerHeight * (scale - 1)) / 2;

    setPosition({
      x: Math.max(-maxX, Math.min(maxX, newX)),
      y: Math.max(-maxY, Math.min(maxY, newY)),
    });
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  return (
    <div
      ref={containerRef}
      className="church-viewer-container"
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseUp}
      style={{
        cursor: isDragging ? "grabbing" : scale > 1 ? "grab" : "default",
      }}
    >
      <img
        src={imagePath}
        alt="Church Design"
        className="church-image"
        style={{
          transform: `scale(${scale}) translate(${position.x}px, ${position.y}px)`,
          transition: isDragging ? "none" : "transform 0.2s ease-out",
        }}
        draggable="false"
      />
      <div className="church-viewer-instructions">
        <p>🔍 Scroll to zoom {scale > 1 && "• 🖱️ Drag to pan"}</p>
      </div>
    </div>
  );
};

export default Church3DViewer;
